import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { roleDestination, workspaceForRole } from "../utils/roleNavigation";

export function useRoleNavigation() {
  const navigate = useNavigate();
  const {
    assignedRoles, user_type, isApproverLoggedIn,
    setActiveRole, setActiveWorkspace,
  } = useAuth();

  return (role) => {
    if (role === "Organization Owner" && user_type === "admin") {
      setActiveRole("");
      setActiveWorkspace("admin");
      navigate("/home/organization");
      return;
    }
    const destination = roleDestination(role);
    if (!destination || !assignedRoles.includes(role)) return;
    if (["CMO/CXO", "Approver"].includes(role) && !isApproverLoggedIn) return;
    setActiveRole(role);
    setActiveWorkspace(workspaceForRole(role));
    navigate(destination);
  };
}
